import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95d99622"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_4 = { class: "section" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "section" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "section box_href" }
const _hoisted_12 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              xs: 24,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_typography_title, { level: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 重磅发布！ ")
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_a_typography_title, { level: 5 }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 《星汉未来DevOps工程效率及运维解决方案白皮书》 ")
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_a_typography_paragraph, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" 云原生时代，全面云架构的新一代 DevOps 工具全景图"),
                    _hoisted_3,
                    _createTextVNode(" 打造适配不同体量、不同阶段企业的工程效能及基础治理综合解决方案 ")
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_a_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "link",
                      class: "button_1",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($props.download($data.href.book)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 点击下载 ")
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.list, (v) => {
      return (_openBlock(), _createElementBlock("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (v.title)
            ? (_openBlock(), _createBlock(_component_a_typography_title, {
                key: 0,
                level: 1
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(v.title), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            : _createCommentVNode("v-if", true),
          (v.text)
            ? (_openBlock(), _createBlock(_component_a_typography_paragraph, { key: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(v.text), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            : _createCommentVNode("v-if", true),
          (v.image)
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                alt: "",
                src: v.image
              }, null, 8 /* PROPS */, _hoisted_6))
            : _createCommentVNode("v-if", true)
        ])
      ]))
    }), 256 /* UNKEYED_FRAGMENT */)),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_a_typography_paragraph, { class: "text" }, {
          default: _withCtx(() => [
            _createTextVNode(" 如需体验SchedulX，感受1分钟1000台的极速扩容能力， 或了解SchedulX的更多强大功能，欢迎扫描下方二维码联系我们， 或填写"),
            _createElementVNode("a", {
              href: $data.href.apply,
              target: "_blank"
            }, "试用申请", 8 /* PROPS */, _hoisted_9),
            _createTextVNode("， 将有技术专家为您提供量身定制的高效运维建议。 ")
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("img", {
          class: "qr",
          alt: "",
          src: $data.file.ImageQR
        }, null, 8 /* PROPS */, _hoisted_10),
        _createVNode(_component_a_button, {
          type: "link",
          class: "button_1",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($props.download($data.href.book)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 查看完整报告 ")
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_a_typography_title, { level: 2 }, {
          default: _withCtx(() => [
            _createTextVNode(" 云原生基础治理平台SchedulX相关资料 ")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_button, {
          type: "link",
          class: "button_1",
          target: "_blank",
          href: $data.href.introduce
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 产品介绍视频 ")
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href"]),
        _createVNode(_component_a_button, {
          type: "link",
          class: "button_1",
          target: "_blank",
          href: $data.href.operate
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 操作说明视频 ")
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href"]),
        _createVNode(_component_a_button, {
          type: "link",
          class: "button_1",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$RQ.GoGSS()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 免费试用 ")
          ]),
          _: 1 /* STABLE */
        })
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}